// Generador de Excel simple sin dependencias externas
export const generateExcelReport = (title, headers, data, filename) => {
  // Crear CSV (compatible con Excel)
  let csvContent = '\uFEFF'; // BOM para UTF-8
  
  // Agregar título
  csvContent += `${title}\n\n`;
  
  // Agregar encabezados
  csvContent += headers.join(',') + '\n';
  
  // Agregar datos
  data.forEach(row => {
    const escapedRow = row.map(cell => {
      // Escapar comillas y agregar comillas si contiene comas
      const cellStr = String(cell || '');
      if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
        return `"${cellStr.replace(/"/g, '""')}"`;
      }
      return cellStr;
    });
    csvContent += escapedRow.join(',') + '\n';
  });
  
  // Crear blob y descargar
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
